var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PayPal',{attrs:{"plan_ids":[
      { title: 'Scout Monat', id: 'P-68V65133UA612230JLY4XGUI', price: '9,99€' },
      { title: 'Scout Jahr', id: 'P-80L68994S5722244LLY6AFBY', price: '99,90€' },
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }